import React, { useState } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { Input } from "antd";
import { ReactComponent as PlusGradient } from "../../../../../assets/svgs/plus-gradient.svg";
import { useSelector } from "react-redux";
import { patchApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import toast from "react-hot-toast";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
import { CheckOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import PopupCard from "../../../../Auth/PopupCard";
const UpdateSection = ({
  onOpen,
  onClose,
  setSectionUpdated,
  sectionId,
  sectionName,
}) => {
  const [section, setsection] = useState(sectionName);
  const [error, setError] = useState(false);
  const clientId = useSelector((state) => state.auth.user._id);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });
  const handleClear = () => {
    setsection("");
    setError(false);
    onClose();
  };
  const triggerPopup = (type, title, message, duration = 2000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(
      () => setShowPopup(false),

      duration,
    );
  };
  const createSection = async (section, clientId, sectionId) => {
    try {
      const body = {
        client_id: clientId,
        // status: "Active",
        name: section,
        description: "This is description",
      };
      const response = await patchApi({
        apiUrl: API_URLS.UPDATE_SECTION(sectionId),
        data: body,
      });
      if (response.success) {
        // Modal.success({
        //   icon: null,
        //   centered: true,
        //   closable: true,
        //   className: "custom-success-modal",
        //   okButtonProps: { style: { display: "none" } },
        //   content: (
        //     <div className="flex flex-col items-center text-center p-4">
        //       <div className="bg-slate-300 p-2 rounded-full">
        //         <CheckOutlined style={{ fontSize: "48px", color: "#06513D" }} />
        //       </div>

        //       <p className="text-[15px] mt-2 mb-1 font-medium">Success!</p>
        //       <h2 className="text-xl font-semibold text-[#000000]">
        //         Section edit successfully.
        //       </h2>
        //     </div>
        //   ),
        // });
        triggerPopup("success", "Success", "Section edit successfully.");

        setTimeout(() => {
          Modal.destroyAll(); // Close all modals
          onClose();
        }, 2000);
      }
    } catch (error) {
      console.log("Error in creating new Section", error);
    }
  };

  const handleSave = async () => {
    if (!section.trim()) {
      setError(true);
      return;
    }
    await createSection(section, clientId, sectionId);
  };

  return (
    <div className="flex justify-center my-4">
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="750px">
        <div>
          <h3 className="text-2xl">Edit Section</h3>
          <div
            style={{
              border: "1px solid #ebedf3",
              borderRadius: "10px",
              padding: "20px",
            }}
          >
            <div className="mb-4">
              <Input
                value={section}
                onChange={(e) => setsection(e.target.value)}
                placeholder="Enter Section Name"
                style={{
                  border: "1px solid #ebedf3",
                  borderRadius: "10px",
                  padding: "10px",
                }}
                className="text-base font-light"
              />
              {error && (
                <p className="text-red-500 text-sm mt-2">
                  Please fill out this field.
                </p>
              )}
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-center gap-4 py-6">
            <CustomButton
              buttonType="primary"
              variant="cancel"
              buttonText="Cancel"
              className="text-sm px-6 py-2 rounded-lg"
              onClick={handleClear}
            />
            <CustomButton
              buttonType="primary"
              variant="ok"
              buttonText="Save"
              className=" text-sm px-6 py-2 rounded-lg"
              onClick={handleSave}
            />
          </div>
          {showPopup && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
              <PopupCard
                type={popupData.type}
                title={popupData.title}
                message={popupData.message}
              />
            </div>
          )}
        </div>
      </DialogBox>
    </div>
  );
};

export default UpdateSection;
